import {Text} from '@chakra-ui/react';
import {colors} from 'components/providers';
import {useTranslation} from 'hooks';
import {FC, useMemo} from 'react';
import {IProduct} from 'types';

interface IProps {
  product: IProduct;
  isMetro?: boolean;
}

export const Labels: FC<IProps> = ({product, isMetro}) => {
  const {t} = useTranslation();
  const {is_new, label, is_weighted_product, label_class} = product;

  const data = useMemo(() => {
    const arr = [];
    if (is_new) {
      arr.push({label: t('BRAND_NEW'), bgColor: colors.pink});
    }
    if (label) {
      arr.push({label, bgColor: label_class});
    }

    if (is_weighted_product && !isMetro) {
      arr.push({label: t('WEIGHTED'), bgColor: colors.orange});
    }
    return arr;
  }, [is_new, is_weighted_product, label, label_class, t, isMetro]);

  return (
    <>
      {data.map(({label, bgColor}, index) => {
        return (
          <Text
            key={label + index}
            position="absolute"
            fontSize={['10px', '14px']}
            fontWeight="700"
            top={[10 + index * 22 + 'px', 30 + index * 30 + 'px']}
            left="-15px"
            p="3px 20px"
            marginTop="0 !important"
            bgColor={bgColor}
            color={colors.white}
            borderRadius="4px"
          >
            {label}
          </Text>
        );
      })}
    </>
  );
};
